import dayjs from 'dayjs';

interface ITimeOptions {
  defaultValue?: string;
  formatType?: string;
}

function time(value?: string | null, options?: ITimeOptions): string {
  if (!value) {
    return options?.defaultValue || '';
  }

  const timeFormatted = dayjs(value).format(options?.formatType || 'HH:MM');

  return timeFormatted;
}

export default time;
